import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthserviceService } from '../@core/services/authservice.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthserviceService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn && this.authService.usuarioValue) {
      if (this.authService.usuarioValue.must_change_password) {
        this.router.navigate(['/cambiar-contrasena']);
        return false;
      }
      return true;
    }
    // Si no está autenticado, redirige al login
    this.router.navigate(['login-portal']);
    return false;
  }
}
